import { useCallback, useState } from 'react';
import { recordCallTransferButtonClicked, recordRequeueClicked, } from '../components/in_call/tool_bar/tools/call_transfer/analytics-utils';
export function useButtonWithMenu(onRequeueTrade, onClick) {
    const [showMenuYn, setShowMenuYn] = useState(false);
    const click = useCallback(event => {
        typeof onClick === 'function' && onClick(event);
        setShowMenuYn(prev => !prev);
        recordCallTransferButtonClicked();
    }, [onClick, setShowMenuYn]);
    const requeueTrade = useCallback(async (name) => {
        recordRequeueClicked(name);
        await onRequeueTrade(name);
        setShowMenuYn(false);
    }, [onRequeueTrade, setShowMenuYn]);
    const closeMenu = useCallback(() => {
        setShowMenuYn(false);
    }, [setShowMenuYn]);
    return {
        showMenuYn,
        click,
        requeueTrade,
        closeMenu,
    };
}
//# sourceMappingURL=use_button_with_menu.js.map